<script lang="ts">
  import { GivenAnswer } from "../../models/GivenAnswer"
  import { Question } from "../../models/Question"
  import RadioButtons from "@components/ui/RadioButtons.svelte"
  import RadioButton from "@components/ui/RadioButton.svelte"

  export let givenAnswer: GivenAnswer
  export let question: Question
</script>

<RadioButtons>
  <div class="sm:flex sm:flex-wrap sm:gap-inline-4">
    {#each [...question.possibleAnswers.items] as possibleAnswer}
      <RadioButton name={`answer-${question.id}`} bind:group={givenAnswer.singleChoiceAnswerId} value={possibleAnswer.id}>
        {possibleAnswer.name}
      </RadioButton>
    {/each}
  </div>
</RadioButtons>
